/** Folding each clinic's value into one, for the All clinics view. */

/** The clinic dropdown's value for every clinic at once. */
export const ALL_CLINICS = 'all';

/** Each clinic's value folded to one value when they agree. */
export type Resolved<T> =
  | { kind: 'none' }
  | { kind: 'value'; value: T }
  | { kind: 'mixed'; byClinic: { clinic: string; value: T }[] };

export function resolveAcrossClinics<T>(
  values: [string, T][],
  clinicName: (id: string) => string
): Resolved<T> {
  if (values.length === 0) return { kind: 'none' };
  const first = values[0][1];
  if (values.every(([, v]) => v === first))
    return { kind: 'value', value: first };
  return {
    kind: 'mixed',
    byClinic: values.map(([id, value]) => ({ clinic: clinicName(id), value })),
  };
}
